/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo, useState } from 'react';
import DafTable from '../../../components/Table/newTable';
import { useFilters } from '../../../helpers/SubjectSearch';
import { SearchFilters } from 'datastake-daf/dist/components';
import TablePagination from '../../../components/Table/pagination';
import { Style } from '../../../components/Forms/projects/table/style';
import { getConfig } from '../../../components/Forms/projects/table/config';

const mod = 'admin';

function Update({
  data = {},
  selectOptions = [],
  tableColumns = [],
  entity = '',
  setActiveFilters = () => { },
  defaultActiveFilters = {},
  children = null,
}) {
  const { t } = useTranslation();
  const [showFilters, setShowFilters] = useState(false);
  const [hasError, setHasError] = useState(false);

  const {
    selectFiltersConfig,
    filtersConfig,
    checkboxConfig,
  } = useMemo(() => {
    const { checkboxConfig, filtersConfig, selectFiltersConfig } = getConfig(entity);
    if (entity === 'locations') {
      const { status, ...filtered } = selectFiltersConfig;
      return {
        checkboxConfig,
        filtersConfig,
        selectFiltersConfig: {
          ...filtered,
        },
      };
    }

    return {
      checkboxConfig,
      filtersConfig,
      selectFiltersConfig,
    };
  }, [entity]);

  const {
    newFiltersConfig,
    pagination,
    activeFilters,
    onSearch,
    defaultFilters,
    onTableChange,
    setPagination,
    onFiltersChange,
  } = useFilters({
    selectFiltersConfig,
    defaultActiveFilters,
    module: mod,
    filtersConfig,
    defaultPageSize: 10,
  });

  useEffect(() => {
    setActiveFilters(activeFilters);
  }, [activeFilters]);

  const dataSource = useMemo(() => data.data, [data]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, total: data.totalItems }));
  }, [data]);

  const canGoNext = useMemo(() => {
    if (pagination.total === 0) {
      return false;
    }

    const pages = Math.ceil(pagination.total / pagination.pageSize);
    if (pagination.current !== pages) {
      return true;
    }

    return false;
  }, [pagination]);

  const canGoPrev = useMemo(() => pagination.current !== 1, [pagination]);

  const goNext = () => {
    if (!canGoNext) {
      return;
    }
    const newPage = pagination.current + 1;
    onTableChange({ ...pagination, current: newPage });
    setPagination((p) => ({ ...p, current: newPage }));
  };

  const goPrev = () => {
    if (!canGoPrev) {
      return;
    }
    const newPage = pagination.current - 1;
    onTableChange({ ...pagination, current: newPage });
    setPagination((p) => ({ ...p, current: newPage }));
  };

  const canClearSearch = useMemo(() => {
    return !!activeFilters.search;
  }, [activeFilters]);

  const searchFilters = (
    <SearchFilters
      t={t}
      showFilters={showFilters}
      setShowFilters={setShowFilters}
      hasError={hasError}
      setHasError={setHasError}
      filtersConfig={newFiltersConfig}
      checkboxConfig={checkboxConfig}
      onSearch={onSearch}
      canClear={canClearSearch}
      activeFilters={activeFilters}
      clearFilters={() => setActiveFilters({})}
    />
  );

  const total = useMemo(() => Math.ceil(pagination.total / pagination.pageSize), [pagination]);

  return tableColumns && tableColumns.length ? (
    <Style>
      <div className="header">
        {searchFilters}
      </div>
      {children}
      <DafTable
        className="no-padding"
        columns={tableColumns}
        data={dataSource}
        selectOptions={selectOptions}
        filtersConfig={selectFiltersConfig}
        onFilterChange={onFiltersChange}
        showFilters={showFilters}
        defaultFilters={defaultFilters}
        onChange={onTableChange}
        pagination={{ ...pagination, showSizeChanger: true }}
        setShowFilters={setShowFilters}
        hideOnLoading={false}
      />
      <TablePagination
        t={t}
        page={pagination.current}
        totalPages={total}
        goPrev={goPrev}
        goNext={goNext}
        canGoNext={canGoNext}
        canGoPrev={canGoPrev}
        totalItems={pagination.total}
        perPage={pagination.perPage}
        loaded
      />
    </Style>
  ) : null;
}

export default Update;
